import api from '../../api'
import type { CommercialStructureApi } from './interfaces'

/** @deprecated Use getCommercialStructureData from `src/services/shared/commercialStructure` instead */
export const getCommercialStructureData = async (version: number) => {
  const response = await api.get<CommercialStructureApi[]>(
    `estrut-comerc/v2/ListarEstruturaComercial`,
  )

  return response.data
}
